export enum DisplayNameControlKeys {
  LEGAL_NAME = 'legal-name',
  PREFERRED_NAME = 'preferred-name',
}

export type DisplayNamePerson = { firstName: string; lastName: string; preferredName?: string };
export type DisplayNameOptions = { alwaysUseLegalName?: boolean };

export interface ResolvedDisplayName {
  firstName: string;
  lastName: string;
  fullName: string;
  preferredName?: string;
  isPreferred: boolean;
  /** Always the legal first name, regardless of the selected display preference. */
  legalFirstName: string;
  /** Always the legal last name, regardless of the selected display preference. */
  legalLastName: string;
  /** Always the full legal name (`legalFirstName legalLastName`), regardless of the selected display preference. */
  legalName: string;
}
